import { axiosClient } from "@/shared/api/axios-client";
import type { OrganizacionAdmin } from "@/lib/types";

export interface CrearOrganizacionInput {
  rfc: string;
  numeroSociedad: string;
  nombre: string;
}

export interface ListarOrganizacionesParams {
  busqueda?: string;
  page?: number;
  pageSize?: number;
}

/** Envelope paginado del backend + conteos del catálogo completo para el header. */
export interface PaginaOrganizaciones {
  items: OrganizacionAdmin[];
  total: number;
  page: number;
  pageSize: number;
  totalCatalogo: number;
  totalActivas: number;
}

export async function listarOrganizacionesAdmin(
  params: ListarOrganizacionesParams = {}
): Promise<PaginaOrganizaciones> {
  const { data } = await axiosClient.get<PaginaOrganizaciones>(
    "/api/admin/organizaciones",
    { params }
  );
  return data;
}

/**
 * Catálogo COMPLETO de organizaciones · loop de páginas (pageSize máx del
 * backend). Lo consumen las vistas que asignan/filtran sobre todo el
 * catálogo (p. ej. admin de usuarios).
 */
export async function listarTodasLasOrganizaciones(): Promise<OrganizacionAdmin[]> {
  const todas: OrganizacionAdmin[] = [];
  for (let p = 1; ; p++) {
    const pagina = await listarOrganizacionesAdmin({ page: p, pageSize: 100 });
    todas.push(...pagina.items);
    if (todas.length >= pagina.total || pagina.items.length === 0) break;
  }
  return todas;
}

export async function crearOrganizacion(
  input: CrearOrganizacionInput
): Promise<OrganizacionAdmin> {
  const { data } = await axiosClient.post<OrganizacionAdmin>(
    "/api/admin/organizaciones",
    input
  );
  return data;
}

export async function renombrarOrganizacion(
  id: string,
  nombre: string
): Promise<OrganizacionAdmin> {
  const { data } = await axiosClient.patch<OrganizacionAdmin>(
    `/api/admin/organizaciones/${id}/nombre`,
    { nombre }
  );
  return data;
}

export async function darDeBajaOrganizacion(
  id: string
): Promise<OrganizacionAdmin> {
  const { data } = await axiosClient.post<OrganizacionAdmin>(
    `/api/admin/organizaciones/${id}/baja`
  );
  return data;
}

export async function reactivarOrganizacion(
  id: string
): Promise<OrganizacionAdmin> {
  const { data } = await axiosClient.post<OrganizacionAdmin>(
    `/api/admin/organizaciones/${id}/reactivar`
  );
  return data;
}
